import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { NOTES_APP_URL } from '../components/Sidebar';

// Old bookmarks and the prior-auth alert email link to /admin?section=... Map them to the new routes.
const MAP = {
  clients: '/clients/manage',
  'prior-auths': '/authorizations',
  users: '/users',
  'invite-codes': '/users?view=invites',
  'sms-reminders': '/users',
};

// Progress notes and the AI Agent pages live in the separate notes app.
const NOTES_APP_SECTIONS = new Set(['notes', 'create-note', 'ai-agent', 'ai-agent-evv']);

export default function LegacyAdminRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const section = params.get('section') || 'clients';
  const leaving = NOTES_APP_SECTIONS.has(section);

  useEffect(() => {
    if (leaving) window.location.replace(`${NOTES_APP_URL}/admin${search}`);
  }, [leaving, search]);

  if (leaving) return <div className="loading-screen"><div className="spinner" /></div>;

  params.delete('section');
  const target = MAP[section] || '/dashboard';
  const rest = params.toString();
  const joiner = target.includes('?') ? '&' : '?';
  return <Navigate to={rest ? `${target}${joiner}${rest}` : target} replace />;
}
